<template>
  <div class="h-screen flex w-full bg-img">
    <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
      <vx-card ref="alterarSenha">
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
              <img
                src="@/assets/images/pages/login/forgot-password.png"
                alt="login"
                class="mx-auto"
              />
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">Trucar sua senha</h4>
                  <p>Insira abaixo sua nova senha e a confirmação para poder atualiza-la.</p>
                </div>

                <template v-if="!invalido">
                  <div class="mb-8">
                    <vs-input
                      type="password"
                      name="password"
                      autocomplete="off"
                      label-placeholder="Senha"
                      v-validate="'required'"
                      v-model="password"
                      ref="password"
                      class="w-full"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('password')"
                    >{{ errors.first('password') }}</span>
                  </div>

                  <div class="mb-8">
                    <vs-input
                      type="password"
                      name="password_confirmation"
                      autocomplete="off"
                      label-placeholder="Confirme a senha"
                      v-validate="'required|confirmed:password'"
                      v-model="password_confirmation"
                      class="w-full"
                    />
                    <span
                      class="text-danger text-sm"
                      v-show="errors.has('password_confirmation')"
                    >{{ errors.first('password_confirmation') }}</span>
                  </div>
                </template>
                <template v-else>
                  <p>O seu token está expirado ou é inválido.</p>
                </template>

                <vs-button type="border" to="/login" class="px-4 w-full md:w-auto">Voltar para login</vs-button>

                <vs-button
                  :disabled="invalido"
                  v-on:click="enviar({email,password,password_confirmation})"
                  class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0"
                >Trocar senha</vs-button>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import api from "@services/api-service";

export default {
  data() {
    return {
      loading: false,
      invalido: false,
      email: null,
      password: null,
      password_confirmation: null
    };
  },
  watch: {
    loading(loading) {
      if (loading) {
        this.$refs.alterarSenha.refreshcard();
      } else {
        this.$refs.alterarSenha.removeRefreshAnimation();
      }
    }
  },
  mounted() {
    this.loading = true;
    this.verificarToken();
  },
  methods: {
    verificarToken() {
      const token = this.$route.params.token;

      api()
        .post("auth/password/verificar-token", { token })
        .then(response => {
          if (!response.data.status) {
            this.tokenInvalido();
          }

          this.email = response.data.data.email;
          this.loading = false;
        })
        .catch(this.tokenInvalido);
    },

    tokenInvalido() {
      this.invalido = true;
      this.loading = false;
    },

    enviar(dados) {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.loading = true;

          const token = this.$route.params.token;

          api()
            .post("/auth/password/reset", { ...dados, token })
            .then(response => {
              this.loading = false;

              this.$vs.dialog({
                title: "Atenção",
                text: response.data.mensagem,
                type: "alert",
                color: "dark",
                acceptText: "Fechar",
                accept: () => {
                  if (response.data.status) {
                    this.$router.replace("/login");
                  }
                }
              });
            })
            .catch(() => {
              this.loading = false;

              this.$vs.dialog({
                title: "Ops!",
                text:
                  "Algo de errado aconteceu, não conseguimos alterar sua senha, tente novamente mais tarde.",
                type: "alert",
                color: "error",
                acceptText: "Fechar"
              });
            });
        }
      });
    }
  }
};
</script>
